import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCurrentDate } from "../utils/getCurrentDate";
import { toast } from "react-toastify";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import FieldWarning from "../components/FieldWarning";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { useCreateAdminMutation } from "../slices/AdminSilce";
import { useLocation } from "react-router-dom";

const CreateAdminScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const { outletId } = state || {};

  const [associateNumber, setAssociateNumber] = useState("");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // const [companyId, setCompanyId] = useState("");
  const [name, setName] = useState("");
  const [gender, setGender] = useState("Male");
  const [workShift, setWorkShift] = useState(1);
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState();
  const [panNumber, setPanNumber] = useState();
  const [associateRole, setAssociateRole] = useState("Associate");
  const [associateRoleId, setAssociateRoleId] = useState("");
  const [recentOtp, setRecentOtp] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(getCurrentDate());
  const [joinedDate, setJoinedDate] = useState(getCurrentDate());

  const [associateNumberPresent, setAssociateNumberPresent] = useState(false);
  const [passwordPresent, setPasswordPresent] = useState(false);
  const [confirmPasswordPresent, setConfirmPasswordPresent] = useState(false);
  const [outletIdPresent, setOutletIdPresent] = useState(false);
  // const [companyIdPresent, setCompanyIdPresent] = useState(false);
  const [namePresent, setNamePresent] = useState(false);
  const [genderPresent, setGenderPresent] = useState(false);
  const [recentOtpPresent, setRecentOtpPresent] = useState(false);
  const [emailPresent, setEmailPresent] = useState(false);
  const [aadharNumberPresent, setAadharNumberPresent] = useState(false);
  const [panNumberPresent, setPanNumberPresent] = useState(false);
  const [joinedDatePresent, setJoinedDatePresent] = useState(false);
  const [dateOfBirthPresent, setDateOfBirthPresent] = useState(false);
  const [addressPresent, setAddressPresent] = useState(false);
  const [pincodePresent, setPincodePresent] = useState(false);
  const [contactNumberPresent, setContactNumberPresent] = useState(false);

  const availableRoles = ["Associate", "Admin", "Super Admin"];
  const workShifts = [1, 2, 3, 4];
  const availableGender = ["Male", "Female", "Other"];
  const roleIds = { "Super Admin": 1, Admin: 2, Associate: 3 };

  const [pwdVisible, setPwdVisible] = useState(false);
  const [confirmPwdVisible, setConfirmPwdVisible] = useState(false);

  const [registerAssociate, { isLoading }] = useCreateAdminMutation();

  // const userInfo = useSelector((state) => state.auth);

  // let { search } = useLocation();
  // const ps = new URLSearchParams(search);
  // const redirect = ps.get("redirect") || "/";

  //   useEffect(() => {
  //     if (userInfo) {
  //       navigate(redirect);
  //     }
  //   }, [userInfo, redirect, navigate]);
  useEffect(() => {
    if (name?.trim().length > 0) {
      setNamePresent(false);
    }

    if (password?.trim().length >= 8) {
      setPasswordPresent(false);
    }
    if (password === confirmPassword) {
      setConfirmPasswordPresent(false);
    }
    if (gender?.length > 1) {
      setGenderPresent(false);
    }

    if (contactNumber?.length === 10 && contactNumber > 1) {
      setContactNumberPresent(false);
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(email) || email?.length === 0) {
      setEmailPresent(false);
    }

    if (aadharNumber?.length === 12 || aadharNumber?.length === 0) {
      setAadharNumberPresent(false);
    }

    if (panNumber?.length > 9 || panNumber?.length === 0) {
      setPanNumberPresent(false);
    }

    if (address?.length > 10 || address?.length === 0) {
      setAddressPresent(false);
    }

    if (pincode?.length === 6 || pincode?.length === 0) {
      setPincodePresent(false);
    }

    if (dateOfBirth < getCurrentDate()) {
      setDateOfBirthPresent(false);
    }

    if (joinedDate <= getCurrentDate()) {
      setJoinedDatePresent(false);
    }

    // if (companyId?.length === 4) {
    //   setCompanyIdPresent(false);
    // }
  }, [
    name,
    gender,
    email,
    aadharNumber,
    dateOfBirth,
    joinedDate,
    address,
    associateNumber,
    contactNumber,
    password,
    confirmPassword,
    pincode,
    panNumber,
  ]);

  const verifyInputFeilds = async () => {
    let fieldValidationSuccess = true;

    if (name?.trim().length < 1 || name?.length > 100) {
      setNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (password?.trim().length < 8 || password?.length > 50) {
      setPasswordPresent(true);
      fieldValidationSuccess = false;
    }
    if (password !== confirmPassword) {
      setConfirmPasswordPresent(true);
      fieldValidationSuccess = false;
    }

    if (gender?.length < 1) {
      setGenderPresent(true);
      fieldValidationSuccess = false;
    }

    if (!contactNumber || contactNumber?.length !== 10) {
      setContactNumberPresent(true);
      fieldValidationSuccess = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email)
      if (!emailRegex.test(email) || email?.length > 300) {
        setEmailPresent(true);
        fieldValidationSuccess = false;
      }
    if (aadharNumber)
      if (aadharNumber?.length !== 12 || Number(aadharNumber) < 0) {
        setAadharNumberPresent(true);
        fieldValidationSuccess = false;
      }
    if (panNumber)
      if (panNumber?.length < 8 || panNumber < 1) {
        setPanNumberPresent(true);
        fieldValidationSuccess = false;
      }

    if (address)
      if (address?.length < 10 || address?.length > 1000) {
        setAddressPresent(true);
        fieldValidationSuccess = false;
      }
    if (pincode)
      if (pincode?.length !== 6 || pincode < 1) {
        setPincodePresent(true);
        fieldValidationSuccess = false;
      }

    if (!dateOfBirth || dateOfBirth >= getCurrentDate()) {
      setDateOfBirthPresent(true);
      fieldValidationSuccess = false;
    }

    if (joinedDate > getCurrentDate()) {
      setJoinedDatePresent(true);
      fieldValidationSuccess = false;
    }

    // if (companyId?.length !== 4) {
    //   setCompanyIdPresent(true);
    //   fieldValidationSuccess = false;
    // }

    if (!fieldValidationSuccess)
      toast.error(
        "Some of the fields have invalid inputs. Please provide valid details"
      );
    return fieldValidationSuccess;
  };

  const submitHandler = async (e) => {
    // e.preventDefault();

    // function wait(ms) {
    //   return new Promise((resolve) => setTimeout(resolve, ms));
    // }
    const isValid = await verifyInputFeilds();

    if (!isValid) {
      console.log("Validation failed. API not called.");
      return; // Stop here if validation failed
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match...");
      return; // Stop here if passwords don't match
    }
    try {
      const resAssociate = await registerAssociate({
        outletId: outletId,
        selectedOutletId: outletId,
        companyId: userInfo?.companyId?._id,
        recentOTP: recentOtp,
        password: password,
        confirmPassword: confirmPassword,
        adminName: name,
        role: associateRole,
        roleId: roleIds[associateRole],
        gender: gender,
        mobileNumber: contactNumber,
        email: email,
        aadharNumber: aadharNumber,
        panNumber: panNumber,
        joinedDate: joinedDate,
        dateOfBirth: dateOfBirth,
        address: address,
        pincode: pincode,
        workShift: workShift,
        token: userInfo.token,
      }).unwrap();
      toast.success("Admin is created successfully");
      setAssociateNumber("");
      setPassword("");
      setConfirmPassword("");
      // setCompanyId("");
      setName("");
      setGender("Male");
      setWorkShift(1);
      setEmail("");
      setAddress("");
      setPincode("");
      setContactNumber("");
      setAadharNumber("");
      setPanNumber("");
      setAssociateRole("Associate");
      setAssociateRoleId("");
      setRecentOtp("");
      setDateOfBirth(getCurrentDate());
      setJoinedDate(getCurrentDate());
      // navigate("/");
    } catch (e) {
      toast.error(e?.data?.error || e?.error || "Something went wrong");
      console.log("API Error:", e);
    }
  };

  const setPwdVisibility = () => {
    setPwdVisible(!pwdVisible);
  };

  const setConfirmPwdVisibility = () => {
    setConfirmPwdVisible(!confirmPwdVisible);
  };

  return (
    <>
      <h6>Admin Registration</h6>

      {/* <Form.Group as={Row} className="my-2" controlId="resistrationCode">
            <Form.Label column="true" sm="3">
              Registration Code * :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                value={regCode}
                onChange={(e) => setRegCode(e.target.value)}
                placeholder="enter Registration code"
              ></Form.Control>
            </Col>
          </Form.Group> */}
      <Row>
        <Col md={6}>
          <Form.Group as={Row} className="my-2" controlId="firstName">
            <Form.Label column="true" sm="3">
              Admin Name <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="enter Name"
              ></Form.Control>{" "}
              {namePresent ? (
                <FieldWarning text="First name should have minimum 1 char and max 100 char" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>

          {/* <Form.Group as={Row} className="my-2" controlId="aadharNumber">
            <Form.Label column="true" sm="3">
              Company Id <label style={{ color: "red" }}>*</label>:
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                pattern="[0-9]*" // Allow only digits
                value={companyId}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setCompanyId(value);
                }}
                placeholder="enter company id"
              />
              {companyIdPresent ? (
                <FieldWarning text="Company Id should be 4 characters long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group> */}

          <Form.Group as={Row} className="my-2" controlId="password">
            <Form.Label column="true" sm="3">
              Password <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <div style={{ display: "flex" }}>
                <InputGroup>
                  {" "}
                  <Form.Control
                    type={pwdVisible ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="enter password"
                  ></Form.Control>{" "}
                  <Button onClick={setPwdVisibility}>
                    {pwdVisible ? <Eye /> : <EyeSlash />}
                  </Button>{" "}
                </InputGroup>
              </div>
              {passwordPresent ? (
                <FieldWarning text="Password should be atleast 8 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="confirmPassword">
            <Form.Label column="true" sm="3">
              Confirm Password <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <div style={{ display: "flex" }}>
                <InputGroup>
                  {" "}
                  <Form.Control
                    value={confirmPassword}
                    type={confirmPwdVisible ? "text" : "password"}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="confirm password"
                  ></Form.Control>{" "}
                  <Button onClick={setConfirmPwdVisibility}>
                    {confirmPwdVisible ? <Eye /> : <EyeSlash />}
                  </Button>
                </InputGroup>
              </div>
              {confirmPasswordPresent ? (
                <FieldWarning text="Password and Confirm Password are not matching" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="gender">
            <Form.Label column="true" sm="3">
              Select Gender <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <Form.Select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                placeholder="Select Gender"
              >
                {availableGender.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
              {genderPresent ? (
                <FieldWarning text="Please select gender" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="associateRole">
            <Form.Label column="true" sm="3">
              Admin Role <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <Form.Select
                value={associateRole}
                onChange={(e) => setAssociateRole(e.target.value)}
                placeholder="Select Associate Role"
              >
                {availableRoles.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="workShift">
            <Form.Label column="true" sm="3">
              Work Shift:
            </Form.Label>
            <Col sm="6">
              <Form.Select
                value={workShift}
                onChange={(e) => setWorkShift(e.target.value)}
                placeholder="Select work Shift "
              >
                {workShifts.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="contactNumber">
            <Form.Label column="true" sm="3">
              Contact Number <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                pattern="[0-9]*"
                value={contactNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setContactNumber(value);
                }}
                placeholder="enter contact number"
              ></Form.Control>
              {contactNumberPresent ? (
                <FieldWarning text="Please provide 10 digit mobile number" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group as={Row} className="my-2" controlId="dateOfBirth">
            <Form.Label column="true" sm="3">
              Date Of Birth <label style={{ color: "red" }}>*</label>:
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="date"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
                placeholder="in format 'YYYY-MM-DD'"
              ></Form.Control>{" "}
              {dateOfBirthPresent ? (
                <FieldWarning text="Please provide valid date of birth" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="joinedDate">
            <Form.Label column="true" sm="3">
              Joined Date <label style={{ color: "red" }}>*</label>:
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="date"
                value={joinedDate}
                onChange={(e) => setJoinedDate(e.target.value)}
                placeholder="in format 'YYYY-MM-DD'"
              ></Form.Control>
              {joinedDatePresent ? (
                <FieldWarning text="Joined date can not be future date" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="email">
            <Form.Label column="true" sm="3">
              Email :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="enter your email"
              ></Form.Control>
              {emailPresent ? (
                <FieldWarning text="Please provide valid e-mail" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="my-2" controlId="address">
            <Form.Label column="true" sm="3">
              Address :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="enter  Address"
              ></Form.Control>
              {addressPresent ? (
                <FieldWarning text="Address should be atleast 10 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="pincode">
            <Form.Label column="true" sm="3">
              Pincode :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                pattern="[0-9]*" // Allow only digits
                value={pincode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setPincode(value);
                }}
                placeholder="enter pincode"
              />
              {pincodePresent ? (
                <FieldWarning text="Please provide valid 6 digit Pincode" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="panNumber">
            <Form.Label column="true" sm="3">
              PAN Number :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                value={panNumber}
                onChange={(e) => setPanNumber(e.target.value)}
                placeholder="enter PAN Number"
              ></Form.Control>
              {panNumberPresent ? (
                <FieldWarning text="Please provide valid PAN number" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="aadharNumber">
            <Form.Label column="true" sm="3">
              Aadhar Number :
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="text"
                pattern="[0-9]*" // Allow only digits
                value={aadharNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setAadharNumber(value);
                }}
                placeholder="enter Aadhar number"
              />
              {aadharNumberPresent ? (
                <FieldWarning text="Please provide 12 digit Aadhar number" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
        </Col>
        <Row
          sm="4"
          style={{
            alignItems: "center",
            justifyContent: "center",
            margin: "2rem 0rem",
          }}
        >
          <Button
            type="submit"
            disabled={isLoading}
            variant="primary"
            style={{ maxWidth: "7rem" }}
            onClick={submitHandler}
          >
            {" "}
            Register
          </Button>
        </Row>
      </Row>
    </>
  );
};

export default CreateAdminScreen;
